import Cookies from 'js-cookie'
const cookiesBanner = document.querySelector('.cookiesBanner');
const cookiesTrigger = document.querySelector('.cookiesTrigger');

if (cookiesBanner) {

    cookiesTrigger.addEventListener('click', () => {
        Cookies.set('cookies', 'clicked')
        cookiesBanner.classList.add('hidden');
    })

    window.addEventListener('load', () => {
        if (Cookies.get('cookies') !== 'clicked') {
            cookiesBanner.classList.remove('hidden');
        }
    })
}